import React, { useState } from "react";

import { useStreamInfo } from "./use-stream-info";

import {
  ScrapeLink,
  ScrapeGender,
  StyledInfoBox,
  SourceRefs,
  ProviderLink
} from "./stream-info.styles";

export default function StreamInfo({ shift }) {
  if (!shift) {
    return "";
  }

  const { id, stream } = shift;

  if (!stream) {
    return "";
  }

  const { sources, sourceMap } = useStreamInfo(
    id,
    shift?.bookings?.ACCEPTED?.map?.(({ member }) => member.id) ?? null
  );

  const [selectedId, setSelectedId] = useState(null);

  const select = id => {
    setSelectedId(id === selectedId ? null : id);
  };

  const source = sourceMap.get(selectedId);

  return (
    <StyledInfoBox>
      <SourceRefs>
        <div>ShiftStream Ref{sources.length > 1 ? "s" : ""}: </div>
        {sources
          .sort((a, b) => a.numberFilled - b.numberFilled)
          .map(({ id, gender, numberRequested, numberFilled }) => (
            <>
              <ScrapeLink
                className={id === selectedId ? "selected" : ""}
                onClick={() => select(id)}
              >
                {id} ({numberFilled}/{numberRequested})
                {gender !== null && <ScrapeGender gender={gender} />}
              </ScrapeLink>
            </>
          ))}
      </SourceRefs>

      {source && (
        <>
          <ProviderLink>
            <p>
              View{" "}
              <a href={source?.url} target="_blank">
                <b>{source.id}</b>
              </a>{" "}
              on{" "}
              <a href={source?.url} target="_blank">
                {stream?.account?.sourceName}
              </a>
            </p>
            {source.candidates.length > 0 && (
              <p>
                Filled by: <b>{source.candidates.join(" & ")}</b>
              </p>
            )}
            {source.candidates.length === 0 && (
              <p>
                Filled by: <b>None</b>
              </p>
            )}
            {source.gender !== null && (
              <p>
                Gender Restricted: <b>{source.gender}</b>
              </p>
            )}
          </ProviderLink>
        </>
      )}
    </StyledInfoBox>
  );
}
